const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const createDeskApi = async (payload) => {
  const token = localStorage.getItem('token');
  try {
    const response = await fetch(
      `${API_BASE_URL}/admin/user/desks`,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );



    const data = await response.json();

        if (!response.ok) {
            throw data;
        }

        return data;
    } catch (error) {
      console.error('Ошибка при создании деска:', error);
        throw error;
    }

};